import type { IconDefinition } from '../index.tsx';

export const iconStickyNote: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconStickyNote',
  icon: [16, 16, [], '', 'M15 1H1V15H8V8H15V1Z M15 10H10V15H11L15 11V10Z'],
};
